<div class="condition-types">
    <div class="title">
        {{'filter types' | translate:['tmc-yard.widgets.filter-administration.condition-types.title',
        translationService.language]}}
    </div>

    <div class="filter-type-groups">
        <div class="filter-type-group" *ngFor="let group of conditionGroups">
            <div class="group-title">
                {{group.nameDictionaryKey | translate: [group.nameDictionaryKey, translationService.language]}}
            </div>
            <div class="filter-type" *ngFor="let type of group.types">
                <div class="drag-handle" draggable="true" (dragstart)="onDragTypeStart($event, type)"
                    (dragend)="onDragTypeEnd($event)">
                    <div aria-hidden="false">
                        <sc-icon iconClass="fa-bars"></sc-icon>
                    </div>
                </div>
                <div class="type-label">
                    {{type.nameDictionaryKey | translate: [type.nameDictionaryKey, translationService.language]}}
                </div>
            </div>
        </div>
    </div>

</div>